import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import * as echarts from 'echarts'
import chinaJson from './static/map/china2.json'
echarts.registerMap('china', chinaJson)

Vue.prototype.$echarts = echarts
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false

import ElementUI from 'element-ui'
import './static/css/element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import i18n from './assets/i18n/index'

import vuescroll from 'vuescroll'

Vue.use(vuescroll, {
  ops: {}, // 在这里设置全局默认配置
  name: 'vueScroll' // 在这里自定义组件名字，默认是vueScroll
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
